import React from 'react';
import { Redirect } from 'react-router';
import {Button,Badge, Form, FormGroup, Label, Input, FormText} from 'reactstrap';
import { getActiveUsersCount,getActiveUsersList,getSpecificUser } from '../functions/adminFunctions';

const required = (val) => val && val.length;
const isNumber = (val) => !isNaN(Number(val));


class AdminUserTools extends React.Component{
    constructor(props){
        super(props);
        this.state={
            userTime:"1",
            userCustomDays:1,
            activeUserCount:"",
            activeUserList:[],
            minRecord:0,
            maxRecord:999999,
            minVerify:0,
            maxVerify:999999,
            // States for finding specific user
            specificUser:"",
            retrievedUser:"",
            specificUserDiv:"",
            // errors
            dayCountError:"",
            recordMinError:"",
            recordMaxError:"",
            verifyMinError:"",
            verifyMaxError:""
        }
    }


    // User Range Queries
    activeUserForDays = (event) =>{
        if(event.target.name!=="inputDays"){
            this.setState({
                userTime:event.target.value,
                userCustomDays:event.target.value==="custom"?365:event.target.value
            });
        }
        else{
            this.setState({
                userCustomDays:event.target.value
            });
        }
    }

    getActiveUsers = (event) =>{
        // prevents data from coming into URL
        event.preventDefault();
        getActiveUsersCount(
            this.state.userCustomDays*24,
            this.state.minRecord,
            this.state.maxRecord,
            this.state.minVerify,
            this.state.maxVerify
        )
        .then((count)=>{
            // console.log("Oh thy almighty!");
            this.setState({
                activeUserCount:"Number of active Users: "+count,
                // activeUserList:[]
            });
        })
        .catch(err=>console.log(err));
    }

    getActiveUserList = () =>{
        getActiveUsersList(
            this.state.userCustomDays*24,
            this.state.minRecord,
            this.state.maxRecord,
            this.state.minVerify,
            this.state.maxVerify
        )
        .then((list)=>{
            console.log(list);
            this.setState({
                activeUserCount:"Number of active Users: "+list.length,
                activeUserList:list
            });
            console.log(typeof(this.state.activeUserList));
        })
        .catch(err=>console.log(err));
    }

    changeLimit = (event) =>{
        console.log(event);
        var name=event.target.name;
        var value=event.target.value;
        if(name==="minRecord"){
            this.setState({
                minRecord:value
            });
        }
        else if(name==="maxRecord"){
            this.setState({
                maxRecord:value
            });
        }
        else if(name==="minVerify"){
            this.setState({
                minVerify:value
            });
        }
        else if(name==="maxVerify"){
            this.setState({
                maxVerify:value
            });
        }
    }

    // Finding Specific User
    findUser = (event) =>{
        this.setState({
            specificUser:event.target.value
        });
    }

    fetchUserServer = ()=>{
        console.log("getSpecificUser");
        getSpecificUser(this.state.specificUser)
        .then((user)=>{
            console.log(user);
            this.setState({
                activeUserList:user,
                activeUserCount:"Number of active Users: "+1,
            });
        })
        .catch((err)=>console.log(err));
    }


    render(){
        if(this.state.activeUserList!=[]){
            var listActiveUser = this.state.activeUserList.map((user)=>{
                // console.log(user);
                return(
                    <div
                        className="mt-2 pl-2 activeUserList">
                        <li key={user.username}>
                            <h6>UserName: {user.username}</h6>
                            <h6>Name: {user.name}</h6>
                            <h6>Record Count: {user.recorded}</h6>
                            <h6>Verify Count: {user.verified}</h6>
                            <h6>Gender: {user.gender===true?"Female":"Male"}</h6>
                        </li>
                    </div>
                );
            });
        }
        return(
            <div className="container mt-2">

                    <div className="row">
                        <h5><Badge>Active users in</Badge></h5>
                    </div>
                    <div className="m-auto">
                        <Form onSubmit={this.getActiveUsers}>
                            <div className="row">
                                <div className="pl-4">
                                    <Label>
                                    <Input
                                        type='radio'
                                        name="day"
                                        value="1"
                                        onChange={this.activeUserForDays}
                                        checked={this.state.userTime === "1"}
                                    />
                                    Last Day</Label>
                                </div>
                                <div className="pl-4">
                                    <Label>
                                    <Input
                                        type='radio'
                                        name="week"
                                        value="7"
                                        onChange={this.activeUserForDays}
                                        checked={this.state.userTime === "7"}
                                    />
                                    Last Week</Label>
                                </div>
                                <div className="pl-4">
                                    <Label>
                                    <Input
                                        type='radio'
                                        name="month"
                                        value="30"
                                        onChange={this.activeUserForDays}
                                        checked={this.state.userTime === "30"}
                                    />
                                    Last Month</Label>
                                </div>
                            </div>
                            <div className="row pl-4">
                                <div>
                                <Label>
                                    <Input
                                        type='radio'
                                        name="custom"
                                        value="custom"
                                        onChange={this.activeUserForDays}
                                        checked={this.state.userTime === "custom"}
                                    /></Label>
                                </div>
                                <div>
                                    <Input
                                        type='text'
                                        name='inputDays'
                                        onChange={this.activeUserForDays}
                                        value={this.state.userCustomDays}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div>
                                    <h6><Badge color="danger">{this.state.dayCountError}</Badge></h6>
                                </div>
                            </div>

                            <div className="mt-2">
                                <div className="row">
                                    <h5><Badge>Limit Record Count</Badge></h5>
                                </div>
                                <div className="row">
                                    <div className="mt-2">
                                        <Label for="text">Min</Label>
                                    </div>
                                    <div className="mb-1 pb-1 col-2">
                                        <Input
                                            type="text"
                                            name="minRecord"
                                            onChange={this.changeLimit}
                                            value={this.state.minRecord}
                                        />
                                    </div>
                                    <div className="mt-2">
                                        <Label for="text">Max</Label>
                                    </div>
                                    <div className="mb-1 pb-1 col-2">
                                        <Input
                                            type="text"
                                            name="maxRecord"
                                            onChange={this.changeLimit}
                                            value={this.state.maxRecord}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div>
                                    <h6><Badge color="danger">{this.state.recordMinError}</Badge></h6>
                                </div>
                                <div className="ml-2">
                                    <h6><Badge color="danger">{this.state.recordMaxError}</Badge></h6>
                                </div>
                            </div>

                            <div className="mt-2">
                                <div className="row">
                                    <h5><Badge>Limit Verify Count</Badge></h5>
                                </div>
                                <div className="row">
                                    <div className="mt-2">
                                        <Label for="text">Min</Label>
                                    </div>
                                    <div className="mb-1 pb-1 col-2">
                                        <Input
                                            type="text"
                                            name="minVerify"
                                            onChange={this.changeLimit}
                                            value={this.state.minVerify}
                                        />
                                    </div>
                                    <div className="mt-2">
                                        <Label for="text">Max</Label>
                                    </div>
                                    <div className="mb-1 pb-1 col-2">
                                        <Input
                                            type="text"
                                            name="maxVerify"
                                            onChange={this.changeLimit}
                                            value={this.state.maxVerify}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div>
                                    <h6><Badge color="danger">{this.state.verifyMinError}</Badge></h6>
                                </div>
                                <div className="ml-2">
                                    <h6><Badge color="danger">{this.state.verifyMaxError}</Badge></h6>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div>
                                    <Button type="submit" color="success">Count</Button>
                                </div>
                                <div className="ml-2">
                                    <Button color="warning" onClick={()=>this.getActiveUserList()}>Get List</Button>
                                </div>
                            </div>
                        </Form>
                    </div>

                    <div className="mt-3"
                        style={{
                            display:this.state.specificUserDiv
                        }}>
                        <div className="row">
                            <div className="mb-1 pb-1">
                                <Input
                                    type="text"
                                    name="username"
                                    onChange={this.findUser}
                                    value={this.state.specificUser}
                                />
                            </div>
                            <div className="ml-1">
                                <h4><Button onClick={()=>this.fetchUserServer()}>Find User</Button></h4>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div>
                            <h6><Badge color="danger">{this.state.usernameError}</Badge></h6>
                        </div>
                    </div>

                    {/* Result */}
                    <div>
                        <div className="row mt-2">
                            <h5><Badge>{this.state.activeUserCount}</Badge></h5>
                        </div>
                        <div>
                            <ul>{listActiveUser}</ul>
                        </div>
                    </div>

                </div>
        );
    }
}

export default AdminUserTools;